import type { ButtonVariant } from '$types/buttonVariant';

export type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export enum ErrorType {
  FULLPAGE,
  INLINE,
  MODAL,
  SILENT,
  TOAST,
  BACKGROUND,
}
export type ActionType = {
  text: string;
  action: () => void;
  buttonVariant?: ButtonVariant;
};

export type ErrorHandler = {
  eventId?: string | null | undefined;
  errorId?: string;
  title?: string;
  rawError: App.Error | null;
  type?: ErrorType;
  message: string;
  actions?: ActionType[];
  severity?: SeverityLevel;
  component?: string;
};

export interface AppError extends App.Error {
  errorIds?: string;
}
